<button
  type="button"
  [id]="title().toLocaleLowerCase().replaceAll(' ', '-') + '-button'"
  [attr.aria-expanded]="isOpen()"
  [attr.aria-controls]="accordionId()"
  (click)="toggle()"
  class="flex w-full items-start justify-between text-left text-gray-900 dark:text-gray-100"
  [class.cursor-pointer]="expandable()"
>
  <h2 class="text-base/7 font-semibold font-header">{{ title() }}</h2>

  @if (expandable()) {
    <span class="ml-6 flex h-7 items-center">
      <svg
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="1.5"
        data-slot="icon"
        aria-hidden="true"
        class="size-6 transition-transform duration-300 ease-in-out in-aria-expanded:rotate-180"
      >
        <path d="M19.5 8.25l-7.5 7.5-7.5-7.5" stroke-linecap="round" stroke-linejoin="round" />
      </svg>
    </span>
  }
</button>

<ng-content select="[preview]" />

<div
  [id]="accordionId()"
  role="region"
  [attr.aria-labelledby]="title().toLocaleLowerCase().replaceAll(' ', '-') + '-button'"
  [attr.data-open]="isOpen() ? '' : null"
  class="grid grid-rows-[0fr] data-[open]:grid-rows-[1fr] transition-[grid-template-rows] duration-600 ease-in-out text-gray-900 dark:text-gray-100"
>
  <div class="overflow-hidden">
    <ng-content />
  </div>
</div>
